import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";

export default function defaultTemplate(TemplateComponent) {
    return withTranslation()(observer(TemplateComponent));
}
